import React from 'react';

export function LoadingSkeleton({ darkMode }) {
  const skeletonStyle = {
    background: darkMode 
      ? 'linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%)'
      : 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: 'loading 1.5s ease-in-out infinite',
    borderRadius: 8
  };

  return (
    <>
      <style>
        {`
          @keyframes loading {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}
      </style>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 1rem' }}>
        {/* Cards de resumo skeleton */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '1rem', 
          flexWrap: 'wrap',
          marginBottom: '2.5rem' 
        }}>
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} style={{
              ...skeletonStyle,
              minWidth: 140,
              maxWidth: 180,
              height: 140,
              flex: '1 1 140px',
              margin: '0.5rem'
            }} />
          ))}
        </div>

        {/* Gráfico skeleton */}
        <div style={{
          background: darkMode ? '#232526' : 'white',
          borderRadius: 18,
          boxShadow: darkMode ? '0 2px 12px #1118' : '0 2px 12px rgba(25, 118, 210, 0.07)',
          padding: '2rem 1.5rem',
          marginBottom: '2rem'
        }}>
          <div style={{ ...skeletonStyle, height: 32, width: 200, marginBottom: '1.5rem' }} />
          <div style={{ ...skeletonStyle, height: 300, width: '100%' }} />
        </div>

        {/* Segundo gráfico skeleton */}
        <div style={{
          background: darkMode ? '#232526' : 'white',
          borderRadius: 18,
          boxShadow: darkMode ? '0 2px 12px #1118' : '0 2px 12px rgba(25, 118, 210, 0.07)',
          padding: '2rem 1.5rem',
          marginBottom: '2rem'
        }}>
          <div style={{ ...skeletonStyle, height: 32, width: 200, marginBottom: '1.5rem' }} />
          <div style={{ ...skeletonStyle, height: 300, width: '100%' }} />
        </div>
      </div>
    </>
  );
}

export function TableSkeleton({ darkMode, rows = 10 }) {
  const skeletonStyle = {
    background: darkMode 
      ? 'linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%)'
      : 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: 'loading 1.5s ease-in-out infinite',
    borderRadius: 4
  };

  return (
    <div style={{ overflowX: 'auto', marginTop: '1rem', width: '100%' }}>
      <table style={{
        borderCollapse: 'collapse',
        width: '100%',
        minWidth: 700,
        background: darkMode ? '#232526' : 'white',
        borderRadius: 10,
        overflow: 'hidden'
      }}>
        <thead style={{ background: darkMode ? '#111' : '#1976d2' }}>
          <tr>
            {[1, 2, 3, 4, 5, 6, 7].map(i => (
              <th key={i} style={{ padding: '1rem' }}>
                <div style={{ ...skeletonStyle, height: 16, width: '80%', margin: '0 auto' }} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex} style={{
              background: darkMode
                ? rowIndex % 2 === 0 ? '#232526' : '#2d2f31'
                : rowIndex % 2 === 0 ? '#f4f8fb' : 'white'
            }}>
              {[1, 2, 3, 4, 5, 6, 7].map(colIndex => (
                <td key={colIndex} style={{ padding: '0.75rem' }}>
                  <div style={{ ...skeletonStyle, height: 14, width: '90%' }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
